import { render, staticRenderFns } from "./TaxManage.vue?vue&type=template&id=664bcd2c&scoped=true&"
import script from "./TaxManage.vue?vue&type=script&lang=js&"
export * from "./TaxManage.vue?vue&type=script&lang=js&"
import style0 from "./TaxManage.vue?vue&type=style&index=0&id=664bcd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bcd2c",
  null
  
)

export default component.exports